import { gql } from 'apollo-angular';

export const queryOperation = gql`
query Operation($ID: String){
  Operation(ID: $ID){
    ID
    name
    state
    description
    widgetID
    communications{
        email{
          isEnabled
          firstName
          lastName
          jobTitle
          recipient
        }
        sms{
          isEnabled
          firstName
          lastName
          jobTitle
          recipient
        }
        call{
          isEnabled
          firstName
          lastName
          jobTitle
          recipient
        }
    }
    settings {        
        devises{
          values
          default
        }
        denialReasons {
          values
          default
        }
        selectProofType
        responsesTypes {
            key   
            name
            addProof     
            proofAdded   
            error    
            errorSize
        }
        fonts {
            normal{
                ID
                URL
            }
            bold{
                ID
                URL
            }
            italic{
                ID
                URL
            }
            boldItalic{
                ID
                URL
            }
        }
        ambassadorStatus{
            labels{
                key
                name  
            }
        }
        operationMsgInactive
    }
    faq {
      order
      title
      subtitle
      description
      media
      mediaThumbnail
      button
      buttonLink
      buttonSeeMore
    }
    pwa {
      name
      description
      languages {
          language {
              ID
              name
              shortCode
          }
      }     
      content{       
        demonstrations{
          isSalesPathButtonVisible
          isValidationByCodeVisible
          isShareButtonVisible          
        }
        questions {
            isShareButtonVisible            
        }
        sales {
          nbMaxSales
          responseType
          responseTextRegex
          responseTextError     
        }  
        validateMatch {
            buttonURL
            legalURL
        }      
        earnings{         
          isAmountGladyVisible
        }
        logo {
          lightLogoMediaID
          darkLogoMediaID
          pwaLogoMediaID
        }        
        sponsor{
          url
          mustAddEmail           
        }
        authentication {          
          signup {         
            isEnabled
            personalStep {             
              checkbox {
                isEnabled
                label
                url
              }              
            }
            additionalStep {      
              phoneNumberOptional
              phoneNumberCountries
              addressCountries
              frenchOption
              englishOption             
            }            
          }          
        }
        settings{          
          biographyEnabled
          checkAvailabilityEnabled    
          productModificationEnabled 
        }
        home {        
          homeMediaID
          homeThumbnailMediaID
          storyMediaIDs{
            ID
            order
            media
            mediaThumbnail
            startDate
            endDate
          }          
          manual{
            iconMediaID
          }
        }        
        news {   
          ID
          title
          titles {
            language{
                shortCode
            }
            text
          }
          description
          descriptions{
            language{
                shortCode
            }
            text
          }
          media
          mediaThumbnail
          startDate
          endDate
          onTop
          isEnabled
          likes {
            ambassadorID
            date
          }
        }
      }
      media {
        ID
        name
        URL
        MIME
        description
      }
      style{
        theme{
          mainColor
          secondaryColor
        }
        common {
          button {
            color
            backgroundColor            
          }
        }
        customCSS
      }
    }
    shop {
        isEnabled
        products {
            ID
            title
            description
            media
            level
            quantity
            quantityMaxPerAmbassador
            quantityAlreadyOrdered
            costInPoints
            isEnabled
            order
        }
    }
    challenges {
        levels {
          name
          maxPoints
          earningsDisplay          
          targets {
            publications
            reviews
            demonstrations
            events
            externals
            sponsoring
            sales
          }
          publications {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          reviews {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          externals {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             responseType
             responseTextRegex
             responseTextError
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          demonstrations{
            isEnabled
            incentive
            devise
            points
            incentiveVisio
            deviseVisio
            pointsVisio
            ambassadorsStatus
            products
            levels
            startDate
            endDate
            externalTarget{
                externalDataTargetID
             }
          }
          events{
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels             
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          sales{
            isEnabled
            incentive
            points
            devise
            commentEnabled
            commentLabel
            checkboxEnabled
            checkboxLabel
            optionalsMediasEnabled
            optionalsMediasType
            optionalsMediasMax
            ambassadorsStatus
            products
            levels            
            startDate
            endDate
            externalTarget{
                externalDataTargetID
             }
          }
        }
        missions{
          name
          targets {
            publications
            reviews
            demonstrations
            events
            externals
            sponsoring
            sales
          }
          publications {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          reviews {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          externals {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             responseType
             responseTextRegex
             responseTextError
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          demonstrations{
            isEnabled            
            incentive
            devise
            points
            incentiveVisio
            deviseVisio
            pointsVisio
            ambassadorsStatus
            products
            levels
            startDate
            endDate
            externalTarget{
               externalDataTargetID
            }
          }
          events{
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          sales{
            isEnabled            
            incentive
            points
            devise
            commentEnabled
            commentLabel
            checkboxEnabled
            checkboxLabel
            optionalsMediasEnabled
            optionalsMediasType
            optionalsMediasMax
            ambassadorsStatus
            products
            levels
            startDate
            endDate
            externalTarget{
                externalDataTargetID
             }
          }
        }
        flash{
          name
          targets {
            publications
            reviews
            demonstrations
            events
            externals
            sponsoring
            sales
          }
          publications {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          reviews {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          externals {
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             responseType
             responseTextRegex
             responseTextError
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }
          demonstrations{
            isEnabled
            incentive            
            devise
            points
            incentiveVisio
            deviseVisio
            pointsVisio
            ambassadorsStatus
            products
            levels
            startDate
            endDate
            externalTarget{
                externalDataTargetID
             }
          }
          events{
             ID
             isEnabled
             devise
             incentive
             points
             description
             title
             hashtags
             link
             buttonLink
             mediaLink
             descriptionLink
             commentEnabled
             commentLabel
             checkboxEnabled
             checkboxLabel
             responseType
             responseTextRegex
             responseTextError
             optionalsMediasEnabled
             optionalsMediasType
             optionalsMediasMax
             isSocialsEnabled
             ambassadorsStatus
             products
             levels
             startDate
             endDate
             externalTarget{
                externalDataTargetID
             }
          }          
          sales{
            isEnabled
            incentive
            points
            devise           
            commentEnabled
            commentLabel
            checkboxEnabled
            checkboxLabel
            optionalsMediasEnabled
            optionalsMediasType
            optionalsMediasMax
            ambassadorsStatus
            products
            levels
            startDate
            endDate
            externalTarget{
               externalDataTargetID
            }
          }
        }
    }
    products {
        ID
        name
        pictureURI
    }
    _pcd {
        targets {
            publications
            reviews
            events
            externals
            demonstrations
            sales
        }
    }
  }
}`;

export const mutationLikeNews = gql`
mutation newsPostLike ($ID: String, $params: String ) { 
    NewsPostLike(ID: $ID, params: $params )
}
`;